import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EmptyFavoriteTimeIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "70"}
      height={height || "157.195"}
      viewBox="0 0 70 157.195"
    >
      <g
        id="Group_10854"
        data-name="Group 10854"
        transform="translate(-1693 -307)"
      >
        <g id="Illustration" transform="translate(787 50)">
          <g
            id="Group_10849"
            data-name="Group 10849"
            transform="translate(906 331)"
          >
            <rect
              id="Rectangle_1862"
              data-name="Rectangle 1862"
              width="70"
              height="70"
              rx="4"
              fill="#ddd"
            />
            <rect
              id="Rectangle_1863"
              data-name="Rectangle 1863"
              width="63.333"
              height="63.333"
              rx="2"
              transform="translate(3.333 3.333)"
              fill="#f9f9f9"
            />
            <rect
              id="Rectangle_1864"
              data-name="Rectangle 1864"
              width="63.333"
              height="3.333"
              transform="translate(3.333 15.833)"
              fill="#ddd"
            />
          </g>
          <g
            id="Group_10848"
            data-name="Group 10848"
            transform="translate(926 360.912)"
          >
            <path
              id="Path_10376"
              data-name="Path 10376"
              d="M23.75,3A8.983,8.983,0,0,0,17,6.135,8.983,8.983,0,0,0,10.25,3,8.17,8.17,0,0,0,2,11.25c0,5.67,5.1,10.29,12.825,17.31L17,30.525l2.175-1.98C26.9,21.54,32,16.92,32,11.25A8.17,8.17,0,0,0,23.75,3Z"
              transform="translate(-2 -3)"
              fill="#fff"
            />
            <path
              id="Path_10375"
              data-name="Path 10375"
              d="M23.75,3A8.983,8.983,0,0,0,17,6.135,8.983,8.983,0,0,0,10.25,3,8.17,8.17,0,0,0,2,11.25c0,5.67,5.1,10.29,12.825,17.31L17,30.525l2.175-1.98C26.9,21.54,32,16.92,32,11.25A8.17,8.17,0,0,0,23.75,3Zm-6.6,23.325-.15.15-.15-.15C9.71,19.86,5,15.585,5,11.25A5.127,5.127,0,0,1,10.25,6,5.864,5.864,0,0,1,15.6,9.54h2.8A5.827,5.827,0,0,1,23.75,6,5.127,5.127,0,0,1,29,11.25C29,15.585,24.29,19.86,17.15,26.325Z"
              transform="translate(-2 -3)"
              fill="#ddd"
            />
          </g>
          <g
            id="Group_10846"
            data-name="Group 10846"
            transform="translate(916 326)"
          >
            <rect
              id="Rectangle_1865"
              data-name="Rectangle 1865"
              width="10"
              height="15"
              rx="5"
              fill="#ddd"
            />
            <rect
              id="Rectangle_1866"
              data-name="Rectangle 1866"
              width="3.333"
              height="8.333"
              rx="1.667"
              transform="translate(3.333 3.333)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_10845"
            data-name="Group 10845"
            transform="translate(936 326)"
          >
            <rect
              id="Rectangle_1869"
              data-name="Rectangle 1869"
              width="10"
              height="15"
              rx="5"
              fill="#ddd"
            />
            <rect
              id="Rectangle_1870"
              data-name="Rectangle 1870"
              width="3.333"
              height="8.333"
              rx="1.667"
              transform="translate(3.333 3.333)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_10847"
            data-name="Group 10847"
            transform="translate(956 326)"
          >
            <rect
              id="Rectangle_1867"
              data-name="Rectangle 1867"
              width="10"
              height="15"
              rx="5"
              fill="#ddd"
            />
            <rect
              id="Rectangle_1868"
              data-name="Rectangle 1868"
              width="3.333"
              height="8.333"
              rx="1.667"
              transform="translate(3.333 3.333)"
              fill="#fff"
            />
          </g>
        </g>
        <ellipse
          id="Ellipse_138"
          data-name="Ellipse 138"
          cx="35"
          cy="2.999"
          rx="35"
          ry="2.999"
          transform="translate(1693 458.196)"
          fill="#ddd"
          opacity="0.5"
        />
        <g id="Bee" transform="translate(1696 307)">
          <g id="Line" transform="translate(0 12.715)">
            <path
              id="Line-2"
              data-name="Line"
              d="M31.878,53.082s-21.639,10.643-30.3-9.106,21.088-42.3,23.972-31.548S-4.148,20.852,7.428,0"
              transform="translate(38.155 0) rotate(43)"
              fill="none"
              stroke="#ddd"
              stroke-width="2"
              stroke-dasharray="5 3"
            />
          </g>
          <g id="bee-2" data-name="bee" transform="translate(38.362)">
            <path
              id="Path_10042"
              data-name="Path 10042"
              d="M5.87,23.906a9.981,9.981,0,0,0,1.935-.2c.326-.065,1.016-.244,1.706-.461,1.33-.419,1.54-.629,1.642-.73a.613.613,0,0,0,.11-.72c-.079-.149-.147-.288-.214-.421a9.83,9.83,0,0,0-.491-.9,7.662,7.662,0,0,0-1.228-1.529,7.752,7.752,0,0,0-2.222-1.625A7.6,7.6,0,0,0,3.924,16.6a3.939,3.939,0,0,0-3.606,1.72c-.595,1.05-.357,2.271.707,3.63a5.969,5.969,0,0,0,2.9,1.717,7.652,7.652,0,0,0,1.94.237Zm0,0"
              transform="translate(0.001 -15.944)"
              fill="#ccc"
              opacity="0.7"
            />
            <path
              id="Path_10043"
              data-name="Path 10043"
              d="M304.855,6.522a.6.6,0,0,0,.1-.008A5.766,5.766,0,0,0,306.5,5.7a5.08,5.08,0,0,0,1.143-1.15,3.138,3.138,0,0,0,.4-3.122A1.606,1.606,0,0,0,306.586.5a2.456,2.456,0,0,0-1.331.454A3.454,3.454,0,0,0,303.816,3.6a4.3,4.3,0,0,0,.526,2.645A.613.613,0,0,0,304.855,6.522Zm0,0"
              transform="translate(-291.469 -0.5)"
              fill="#bbb"
            />
            <path
              id="Path_10044"
              data-name="Path 10044"
              d="M359.254,188.241a6.268,6.268,0,0,0-5.6-3.877,8.438,8.438,0,0,0,.263,5.86,8.141,8.141,0,0,0,4.124,4.707A6.293,6.293,0,0,0,359.254,188.241Zm0,0"
              transform="translate(-338.933 -176.962)"
              fill="#fb972e"
            />
            <path
              id="Path_10045"
              data-name="Path 10045"
              d="M225.942,192.933a9.886,9.886,0,0,1-.446-6.2,6.3,6.3,0,0,0-1.287.379,9.942,9.942,0,0,0-3.194,2.453,12.911,12.911,0,0,0,.9,4.85,12.658,12.658,0,0,0,3.139,4.761c.271.011.536.018.791.018a8.6,8.6,0,0,0,3.175-.469,6.274,6.274,0,0,0,1.173-.639A9.666,9.666,0,0,1,225.942,192.933Zm0,0"
              transform="translate(-212.099 -179.233)"
              fill="#333"
            />
            <path
              id="Path_10046"
              data-name="Path 10046"
              d="M130.293,290.383q-.151.2-.3.407c-1.468,2.051-2.345,4.074-2.345,5.412,0,.588.609.919,1.14,1.141a13.215,13.215,0,0,0,2.042.616,26.639,26.639,0,0,0,2.837.485,14.487,14.487,0,0,1-2.448-4.174A14.7,14.7,0,0,1,130.293,290.383Zm0,0"
              transform="translate(-122.474 -278.651)"
              fill="#fb972e"
            />
          </g>
          <g id="Plus" transform="translate(60.812 30.177)">
            <line
              id="Line_225"
              data-name="Line 225"
              y2="4"
              transform="translate(2)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
            <line
              id="Line_226"
              data-name="Line 226"
              y2="4"
              transform="translate(4 2) rotate(90)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
          </g>
          <g
            id="Ellipse_136"
            data-name="Ellipse 136"
            transform="translate(54.412 42.577)"
            fill="#fff"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="0.8" cy="0.8" r="0.8" stroke="none" />
            <circle cx="0.8" cy="0.8" r="0.3" fill="none" />
          </g>
          <g
            id="Ellipse_137"
            data-name="Ellipse 137"
            transform="translate(23.212 16.977)"
            fill="none"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="1.6" cy="1.6" r="1.6" stroke="none" />
            <circle cx="1.6" cy="1.6" r="1.1" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
}
